export default __webpack_public_path__ + "static/security-f1d6a5b36e991d32cb7203d4c055657e.svg";